import { useState, useEffect } from 'react'

const passwordTranslations = ['password', 'contraseña', 'senha', 'pass']

const validateWord = (word, arr) => {
  const validations = Array.isArray(arr) ? arr : [arr]
  return validations.map(el => el.length > 2 && word.toLowerCase().includes(el.toLowerCase())).some(v => v === true)
}

const usePasswordValidation = ({ firstName, lastName, spaceNames }) => {
  const [password, setPassword] = useState('')
  const [validationResult, setValidationResult] = useState(null)
  const [isValid, setIsValid] = useState(false)

  const validateMinLength = (password) => password.length >= 8
  const validateUpperCase = (password) => /[A-Z]/.test(password)
  const validateLowerCase = (password) => /[a-z]/.test(password)
  const validateNumber = (password) => /\d/.test(password)

  const validateForbiddenTerms = (password) => {
    return {
      firstNameOrLastName: !validateWord(password, firstName) && !validateWord(password, lastName),
      spaceName: spaceNames?.find( spaceName => spaceName && validateWord(password, spaceName) ) === undefined,
      auravant: !password.toLowerCase().includes('auravant'),
      passwordOrPass: passwordTranslations.every((term) => !password.toLowerCase().includes(term))
    }
  }

  const checkPasswordValidity = (password ) => {
    const result = {
      minLength: validateMinLength(password),
      hasUpperCase: validateUpperCase(password),
      hasLowerCase: validateLowerCase(password),
      hasNumber: validateNumber(password),
      forbiddenTerms: validateForbiddenTerms(password)
    }

    setIsValid(Object.keys(result).map(k => {
      if (k === 'forbiddenTerms') {
        return Object.keys(result[k]).map(kk => result[k][kk]).every(v => v === true)
      }

      return result[k]
    }).every(v => v === true))

    setValidationResult(result)
  }

  useEffect(() => {
    if (password !== '') {
      checkPasswordValidity(password)
    } else {
      setValidationResult(null)
    }
  }, [password])

  return {
    password,
    setPassword,
    isValid,
    validationResult
  }
}

export default usePasswordValidation
